export default {
  pages: {
    vbm: true,
  },
};
